/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../redux/reducers/reducer'


import PillarLegs from '../../PillarLegs';
import LeftPorchLeg from '../../PillarLegs/LeftPorchLeg';
import RightPorchLeg from '../../PillarLegs/RightPorchLeg';

const Legs = ({ overlapTrussArr, normalMap, envMap, setLeanToTrussPosArr, dragging }) => {

    const [isEqualLeftHeight, setIsEqualLeftHeight] = useState(false);
    const [isEqualRightHeight, setIsEqualRightHeight] = useState(false);
    const [isEqualFrontHeight, setIsEqualFrontHeight] = useState(false);
    const [isAction, setIsAction] = useState(false);
    const [leftPorchLength, setLeftPorchLength] = useState(0);
    const [leanToLength, setLeanToLength] = useState(0)
    const [angle, setAngle] = useState(Math.atan(params.b_l_t_r_pF / 12));

    const trimThickness = 0.2;
    const angleOffset = useMemo(() => {
        return (Math.atan(params.b_l_t_r_pF / 12) - angle);
    }, [params.b_l_t_r_pF, angle]) 
    const trimOffsetHeight = (params.p_r_p / 12) * trimThickness;
    const leanRoofLeftHeight = (params.b_l_t_r_p / 12) * params.lean_p_w;
    const leanRoofRightHeight = (params.b_l_t_r_pR / 12) * params.leanR_p_w;
    const leanRoofFrontHeight = (params.b_l_t_r_pF / 12) * params.leanF_p_w;
    
    /************** ********************** ***************/

    useMemo(() => {
        if(params.p_h === leanRoofLeftHeight + params.lean_p_h) setIsEqualLeftHeight(true)
        else setIsEqualLeftHeight(false)
        if(params.p_h === leanRoofRightHeight + params.leanR_p_h) setIsEqualRightHeight(true)
        else setIsEqualRightHeight(false)
        if(params.p_h === leanRoofFrontHeight + params.leanF_p_h) setIsEqualFrontHeight(true)
        else setIsEqualFrontHeight(false)
    
    }, [leanRoofFrontHeight, leanRoofLeftHeight, leanRoofRightHeight, params.p_h, params.lean_p_h, params.leanR_p_h, params.leanF_p_h])

    useMemo(() => {
        if ((isEqualLeftHeight && params.add_left_front_lean_porch && isEqualRightHeight && params.add_right_front_lean_porch)){
            setAngle(Math.atan((leanRoofRightHeight - trimOffsetHeight) / (params.leanF_p_w)))
            setIsAction(true)
        } else if ((isEqualLeftHeight && params.add_left_front_lean_porch)) {
            setAngle(Math.atan((leanRoofLeftHeight - trimOffsetHeight) / (params.leanF_p_w)))
            setIsAction(true)
        } else if ((isEqualRightHeight && params.add_right_front_lean_porch)) {
            setAngle(Math.atan((leanRoofRightHeight - trimOffsetHeight) / (params.leanF_p_w)))
            setIsAction(true)
        } else {
            setAngle(Math.atan(params.b_l_t_r_pF / 12))
            setIsAction(false)
        }
    }, [isEqualLeftHeight, isEqualRightHeight, leanRoofLeftHeight, leanRoofRightHeight, trimOffsetHeight, params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.b_l_t_r_pF, params.leanF_p_w])


    return (
        <>
            <PillarLegs leanToKey={'front'} angleOffset={angleOffset} setLeanToTrussPosArr={setLeanToTrussPosArr} normalMap={normalMap} envMap={envMap} overlapTrussArr={overlapTrussArr} leftPorchLength={leftPorchLength} setLeanToLength={setLeanToLength} dragging={dragging} />
            {params.add_left_front_lean_porch && <LeftPorchLeg leanToKey={'front'} isAction={isAction} angle={angle} trimOffsetHeight={trimOffsetHeight} angleOffset={angleOffset}  overlapTrussArr={overlapTrussArr} setLeanToTrussPosArr={setLeanToTrussPosArr} setLeftPorchLength={setLeftPorchLength} leftPorchLength={leftPorchLength} normalMap={normalMap} envMap={envMap} />}
            {params.add_right_front_lean_porch && <RightPorchLeg leanToKey={'front'} isAction={isAction} angle={angle} trimOffsetHeight={trimOffsetHeight} angleOffset={angleOffset}  overlapTrussArr={overlapTrussArr} setLeanToTrussPosArr={setLeanToTrussPosArr} leanToLength={leanToLength} leftPorchLength={leftPorchLength} normalMap={normalMap} envMap={envMap} />}
        </>
    )
}

export default Legs

/**
 * @params
 *  

    buildingWidth       :    params.p_w
    buildingLength      :    params.p_d
    buildingHeight      :    params.p_h
    roofPitch           :    params.p_r_p
    roofStyleIndex      :    params.p_r_s
    leanRoofWidth       :    params.leanF_p_w
    leanRoofLength      :    params.leanF_p_d
    leanRoofHeight      :    params.leanF_p_h
    leanRoofPitch       :    params.b_l_t_r_pF
    wallState           :    params.p_f_w
    leanPorchLeftState  :    params.add_left_front_lean_porch
    leanPorchRightState :    params.add_right_front_lean_porch
    leanToAlignState    :    params.leantoAlignmentFront
    leanRoofLeftPitch   :    params.b_l_t_r_p
    leanRoofRightPitch  :    params.b_l_t_r_pR
    leftLeanHeight      :    params.lean_p_h
    rightLeanRoofHeight :    params.leanR_p_h

 */